import {Component} from 'react';
import {withRouter} from 'react-router-dom';
import $ from 'jquery';
import ReactGA from 'react-ga';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {

    if (this.props.location !== prevProps.location) {
      ReactGA.pageview(window.location.pathname + window.location.search);

      if (
        (
          !this.props.location.pathname.includes('lei') &&
          !this.props.location.pathname.includes('validador') &&
          !this.props.location.pathname.includes('val')
        )
        ||
        (
          this.props.location.pathname.includes('validador/integre') &&
          this.props.location.pathname.includes('val/integre')
        )
      ) {
        window.scrollTo(0, 0);
      }

    }

    const navbarSupportedContent = $("#navbarSupportedContent");
    if (navbarSupportedContent.hasClass('show')) {
      navbarSupportedContent.collapse('hide');
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js